import { Button, Input, StatusChip, Table, Text } from "@fragments";


import Popper from "@components/Popper";
import ManageIntegration from "../features/ManageIntegration";
import IntegrationLogs from "../features/IntegrationLogs";

import { MoreVertRounded } from "@mui/icons-material";

import { EVENTS } from "../enums/platforms";
import PlatformLogo from "../components/PlatformLogo";

import './styles.scss';


function IntegrationStatus({ item, onToggle }) {
    const label = !item.active
        ? 'Inativo'
        : item.direction === 'inbound' ? 'Recebendo' : 'Enviando';

    return (
        <>
            <Text.span contrast={6} left={
                <div className={`live-indicator${!item.active ? ' live-indicator--off' : ''}`} />
            }>{label}</Text.span>
            <Input.Switch
                value={item.active}
                onChange={() => onToggle(item)}
            />
        </>
    );
}


export default function IntegrationsView({
    loading,
    communityLoading,
    community,
    integrations,
    pagination,
    popperRef,
    manageModalRef,
    logsModalRef,
    handleLoad,
    handleToggle,
    handleOpenOptions,
}) {
    const columns = [
        {
            id: 'platform-logo',
            title: '',
            className: 'pl-1',
            loadingWidth: 80,
            allowReorder: false,
            customRender: (item) => (
                <PlatformLogo platformKey={item.platform} />
            ),
        },
        {
            id: 'plan',
            title: 'Plano',
            grow: 1,
            loadingWidth: 120,
            customRender: (item) => {
                const plan = community?.plans?.find(
                    (p) => p.id == item.plan_id || p.id == item.plan
                );
                return <Text.span contrast={7}>{plan?.label ?? 'Todos os planos'}</Text.span>;
            },
        },
        {
            id: 'name',
            title: 'Nome da integração',
            grow: 2,
            loadingWidth: 120,
            customRender: (item) => {
                return <Text.span contrast={7}>{item.name}</Text.span>;
            },
        },
        {
            id: 'event',
            title: 'Evento',
            align: 'center',
            className: 'integration-evento-col',
            loadingWidth: 160,
            customRender: (item) => (
                <StatusChip.Default text={EVENTS[item.event]} />
            ),
        },
        {
            id: 'status',
            title: 'Status',
            align: 'center',
            display: 'row',
            loadingWidth: 130,
            customRender: (item) => (
                <IntegrationStatus item={item} onToggle={handleToggle} />
            ),
        },
    ];


    return (
        <div className="">
            <div className="mt-4 px-4">
                <Text.h2 weight={500}>Integrações conectadas</Text.h2>
                <Text.span contrast={7} style={{ maxWidth: '250px' }}>Você pode enviar dados do Ginastee para outras plataformas através das integrações.</Text.span>
                <Table
                    id="community-integrations"
                    columns={columns}
                    className="mt-4"
                    data={integrations}
                    loading={loading || communityLoading}
                    contained={true}
                    emptyMessage="Nenhuma integração configurada"
                    emptySubtitle="Conecte sua comunidade com plataformas externas para automatizar ações."
                    enablePagination={true}
                    pages={pagination.pages}
                    records={pagination.records}
                    page={pagination.page}
                    onSelectPage={(page) => handleLoad(page)}
                    actionsComponent={(item) => (
                        <Button
                            color="overlay"
                            size="small"
                            icon={<MoreVertRounded fontSize="small" />}
                            onClick={(e) => handleOpenOptions(e, item)}
                        />
                    )}
                />

            </div>

            <Popper controlRef={popperRef} />

            <ManageIntegration modalRef={manageModalRef} community={community} />
            <IntegrationLogs modalRef={logsModalRef} />
        </div>
    );
}
